import { render, staticRenderFns } from "./BindUsersMZStats.vue?vue&type=template&id=1dca00ec&scoped=true"
import script from "./BindUsersMZStats.vue?vue&type=script&lang=js"
export * from "./BindUsersMZStats.vue?vue&type=script&lang=js"
import style0 from "./BindUsersMZStats.vue?vue&type=style&index=0&id=1dca00ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dca00ec",
  null
  
)

export default component.exports